import { bufferParamsAPI } from "./api";

export const getBufferParamsList = async (params = {}) => {
  try {
    const res = await bufferParamsAPI.getList(params);
    return res?.data?.map((item, i) => ({ ...item, index: i + 1 }));
  } catch (e) {}
};

export const getFloors = async (params) => {
  try {
    const res = await bufferParamsAPI.getFloors(params);
    return (
      res?.data?.map((item) => ({
        value: item.level_num,
        label: item.level_num.toString(),
      })) || []
    );
  } catch (e) {
    return [];
  }
};

export const deleteBufferParams = async (floor_buffer_ids, params = {}) => {
  if (!Array.isArray(floor_buffer_ids) || !floor_buffer_ids?.length) return;
  const body = { floor_buffer_ids: floor_buffer_ids };
  try {
    const res = await bufferParamsAPI.deleteParam(body, params);
    return res?.data;
  } catch (e) {}
};

export const deleteRevitBufferParams = async (
  floor_buffer_ids,
  params = {}
) => {
  if (!Array.isArray(floor_buffer_ids) || !floor_buffer_ids?.length) return;
  const body = { floor_buffer_ids: floor_buffer_ids };
  try {
    const res = await bufferParamsAPI.deleteRevitParam(body, params);
    return res?.data;
  } catch (e) {}
};

export const updateBufferParams = async (
  floor_buffer_ids,
  floor_param_type_id,
  params = {}
) => {
  if (!Array.isArray(floor_buffer_ids) || !floor_buffer_ids?.length) return;
  const body = {
    floor_buffer_ids: floor_buffer_ids,
    floor_param_type_id: floor_param_type_id,
  };
  try {
    const res = await bufferParamsAPI.updateParam(body, params);
    return res?.data;
  } catch (e) {}
};

export const bufferParamColumns = [
  {
    name: "index",
    field: "index",
    label: "№",
    align: "center",
  },
  {
    name: "floor_param_type_name",
    field: "floor_param_type_name",
    label: "Тип",
    align: "left",
  },
  {
    name: "room_name",
    field: "room_name",
    label: "Комната",
    align: "center",
  },
  {
    name: "floor_buffer_id",
    field: "floor_buffer_id",
    label: "floor_buffer_id",
    align: "center",
  },
  {
    name: "floor_param_id",
    field: "floor_param_id",
    label: "floor_param_id",
    align: "left",
  },
  {
    name: "param_geom",
    field: "param_geom",
    label: "Координаты",
    align: "left",
  },
  {
    name: "rowversion",
    field: "rowversion",
    label: "Дата создания",
    align: "center",
  },
  {
    name: "code",
    field: "code",
    label: "Код",
    align: "left",
  },
];
